// 下载文件名解析：优先 content-disposition 的 filename*=UTF-8''（RFC 5987），兜底 filename="..." 形态

/**
 * 从 content-disposition 响应头解析下载文件名
 * @param {string|undefined} contentDisposition 响应头 content-disposition 原始值
 * @param {string} [fallback='download.docx'] 解析失败时的兜底文件名
 * @returns {string} 文件名（filename* 先按查询串口径将 '+' 还原为空格，再 decodeURIComponent）
 */
export function resolveDownloadFileName(contentDisposition, fallback = 'download.docx') {
  if (!contentDisposition) return fallback
  // filename*=UTF-8''%E6%8A%A5%E9%94%80.docx 形态（后端中文文件名走此通道）
  const starMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (starMatch) {
    try {
      const decoded = decodeURIComponent(starMatch[1].trim().replace(/\+/g, ' '))
      // 空值（如 filename*=UTF-8'' 或仅空白）不落文件名，继续走兜底
      if (decoded) return decoded
    } catch {
      // 非法编码串，继续走兜底
    }
  }
  const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]*)"/)
  if (quotedMatch && quotedMatch[1]) return quotedMatch[1]
  const bareMatch = contentDisposition.match(/filename\s*=\s*([^;]+)/)
  if (bareMatch && bareMatch[1].trim()) return bareMatch[1].trim()
  return fallback
}
